<template>
    <div class="contact-page">
        <div class="container container--mw-xxxl login-page__container">
            <div class="row justify-content-between">
                <div class="col contact-page__column">
                    <FormulateForm @submit="submitForm">
                        <h1 class="formulate-form__heading">Contact us</h1>

                        <FormulateInput v-model="contactname" type="text" label="Name" validation="required"
                            :wrapper-class="['formulate-input-wrapper--container']"
                            :label-class="['formulate-input-label--contained']"
                            :element-class="['formulate-input-element--contained']" />

                        <FormulateInput v-model="contactemail" type="email" label="Email" validation="required|email"
                            :wrapper-class="['formulate-input-wrapper--container']"
                            :label-class="['formulate-input-label--contained']"
                            :element-class="['formulate-input-element--contained']" />

                        <FormulateInput v-model="contactmessage" type="textarea" name="message" label="Message"
                            placeholder="Let us know how we can help you today" validation="required"
                            :label-class="['formulate-input-label--hidden']" />

                        <FormulateInput type="checkbox" label="I am an existing Khonsu customer"
                            :wrapper-class="['formulate-input-wrapper--checkbox']"
                            :label-class="['formulate-input-label--checkbox']" />

                        <FormulateInput type="checkbox" label="I’d like to opt into your marketing material"
                            :wrapper-class="['formulate-input-wrapper--checkbox']"
                            :label-class="['formulate-input-label--checkbox']" />

                        <div class="formulate-form__form-footer">
                            <FormulateInput type="submit" name="SEND" :input-class="'btn formulate-form__submit'" />
                        </div>
                        <div v-if="success">
                            Thank you! Your message was received.
                        </div>
                    </FormulateForm>
                </div>

                <div class="col-12 col-lg-1">
                    <span class="contact-page__or">OR</span>
                </div>

                <div class="col contact-page__column">
                    <div class="contact-page__contact-details">
                        <ul class="contact-page__list">
                            <li class="contact-page__list-item contact-page__list-item--large">Email us at</li>

                            <li class="contact-page__list-item">
                                <a href="mailto:info@khonsubrandlab.com"
                                    class="contact-page__list-item-link">info@khonsubrandlab.com</a>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContaktPage',
    metaInfo: {
        title: 'Khonsu - ContaktPage'
    },
    data: function () {
        return {
            contactemail: null,
            contactname: null,
            contactmessage: null,
            senderPhone: null,
            success: false
        }
    },
    methods: {
        async submitForm() {
            let ContactUs = await this.$store.dispatch('ContactUs/contactUs',
                {
                    'contactemail': this.contactemail,
                    'contactname': this.contactname,
                    'contactmessage': this.contactmessage,
                    'senderPhone': this.senderPhone,
                });

            console.log('Contact Form Response:', ContactUs);

            this.success = ContactUs

        }
    }
}
</script>
